export default {
 footer: {
     ageRestriction: "แพลตฟอร์มของเราจำกัดสำหรับผู้ใช้ที่มีอายุ 18 ปีขึ้นไปเท่านั้น การพนันอาจทำให้เสพติดได้ โปรดเล่นอย่างมีความรับผิดชอบและเพื่อความบันเทิงเท่านั้น สำหรับข้อมูลเพิ่มเติม โปรดไปที่หน้าการเล่นเกมอย่างรับผิดชอบของเรา",
     followUs: "ติดตามเรา",
     company: "บริษัท",
     legal: "ข้อกฎหมาย",
     support: "ฝ่ายสนับสนุน",
     gameProviders: "ผู้ให้บริการเกม",
     copyright: "Copyright © 2019-2026 LOGO. สงวนลิขสิทธิ์ทั้งหมด.",
	 documents: "เอกสาร",
   }
}
